/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispositionSagasRefetchBookingQueryVariables = {
    id: string;
};
export type DispositionSagasRefetchBookingQueryResponse = {
    readonly booking: {
        readonly bookingId: string;
        readonly contractColor: string | null;
        readonly hasVehicle: boolean | null;
    } | null;
};
export type DispositionSagasRefetchBookingQuery = {
    readonly response: DispositionSagasRefetchBookingQueryResponse;
    readonly variables: DispositionSagasRefetchBookingQueryVariables;
};



/*
query DispositionSagasRefetchBookingQuery(
  $id: String!
) {
  booking(id: $id) {
    bookingId
    contractColor
    hasVehicle
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Booking",
    "kind": "LinkedField",
    "name": "booking",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contractColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasVehicle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DispositionSagasRefetchBookingQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DispositionSagasRefetchBookingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb1dcb5b518238f1a99b5509f1365e15",
    "id": null,
    "metadata": {},
    "name": "DispositionSagasRefetchBookingQuery",
    "operationKind": "query",
    "text": "query DispositionSagasRefetchBookingQuery(\n  $id: String!\n) {\n  booking(id: $id) {\n    bookingId\n    contractColor\n    hasVehicle\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ac2ed51ed0c0e25ec5d7a20c5eb66708';
export default node;
